import React, { useMemo, useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { useLocation } from 'react-router-dom';
import HelpDialog from '../../dialogs/HelpDialog';
import { getHelpMessageForKey } from '../../../common/helpMessages';

const resolveHelpMessageKey = (pathname, search) => {
  const normalizedPathname = pathname ? pathname.replace(/\/+$/, '') || '/' : '/';

  if (normalizedPathname === '/owner') {
    const params = new URLSearchParams(search);
    return params.get('id') !== null ? 'ownerSettings' : 'ownerCreate';
  }

  return normalizedPathname;
};

const HelpButtonContent = ({ iconButtonSx, helpMessageKey }) => {
  const [isOpen, setIsOpen] = useState(false);
  const helpContent = useMemo(() => getHelpMessageForKey(helpMessageKey), [helpMessageKey]);

  if (!helpContent) {
    return null;
  }

  return (
    <>
      <Tooltip title="ヘルプ">
        <IconButton
          color="inherit"
          aria-label="ヘルプを開く"
          onClick={() => setIsOpen(true)}
          sx={iconButtonSx}
        >
          <HelpOutlineIcon />
        </IconButton>
      </Tooltip>
      <HelpDialog
        isOpen={isOpen}
        title={helpContent.title}
        messages={helpContent.messages}
        onClose={() => setIsOpen(false)}
      />
    </>
  );
};

const LocationHelpButton = ({ iconButtonSx }) => {
  const { pathname, search } = useLocation();
  const helpMessageKey = useMemo(
    () => resolveHelpMessageKey(pathname, search),
    [pathname, search]
  );

  return <HelpButtonContent iconButtonSx={iconButtonSx} helpMessageKey={helpMessageKey} />;
};

const HelpButton = ({ iconButtonSx, staticHelpMessageKey }) => {
  if (staticHelpMessageKey) {
    return <HelpButtonContent iconButtonSx={iconButtonSx} helpMessageKey={staticHelpMessageKey} />;
  }

  return <LocationHelpButton iconButtonSx={iconButtonSx} />;
};

export default HelpButton;
